import { writable } from 'svelte/store'

export enum MembershipPlanId {
	FREEMIUM = 'PLAN_ID_FREEMIUM',
	STARTER = 'PLAN_ID_STARTER',
	BUSINESS = 'PLAN_ID_BUSINESS',
	ENTERPRISE = 'PLAN_ID_ENTERPRISE',
	ENTERPRISE_PLUS = 'PLAN_ID_ENTERPRISE_PLUS',
	NETWORK = 'PLAN_ID_NETWORK',
	NETWORK_PLUS = 'PLAN_ID_NETWORK_PLUS',
	CUSTOM = 'PLAN_ID_CUSTOM',
}

export const membershipPlanId = writable<MembershipPlanId>()

export const notSelfServicePlans = [
	MembershipPlanId.NETWORK,
	MembershipPlanId.NETWORK_PLUS,
	MembershipPlanId.ENTERPRISE_PLUS,
]
